import { motion } from "framer-motion";
import mobile from "@/assets/images/mobile.png";

export default function VisionSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-linear-to-b from-green-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left side - Text & Button */}
          <motion.div
            className="order-2 lg:order-1 space-y-6"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="text-base sm:text-lg lg:text-4xl text-slate-600 leading-relaxed font-medium">
              Use the app to order from your favourite restaurants, shop
              groceries and everyday essentials, and discover exclusive Mystery
              Bags - All from one smart platform.
            </p>

            <motion.button
              className="mt-4 px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white text-base font-semibold rounded-full shadow-md hover:shadow-emerald-500/30 transition-all duration-300 transform hover:scale-105"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
              viewport={{ once: true }}
            >
              Download the App
            </motion.button>
          </motion.div>

          {/* Right side - Image */}
          <motion.div
            className="order-1 lg:order-2 flex justify-center lg:justify-end"
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.img
              src={mobile}
              alt="Mobile App Preview"
              className="w-full h-full max-w-md object-cover"
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
              whileHover={{ scale: 1.05 }}
              viewport={{ once: true }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
